import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { InputAdornment, IconButton } from '@material-ui/core';
import { InputAdornmentProps } from '@material-ui/core';

export type SearchInputAdornmentProps = Omit<InputAdornmentProps, "position"> & {
    onButtonClick: VoidFunction
    disabled?: boolean
}

export function SearchInputAdornment ({ disabled, onButtonClick, ...props }: SearchInputAdornmentProps) {
    return (
        <InputAdornment {...props} position="end">
            <IconButton onClick={onButtonClick} disabled={disabled}>
                <SearchIcon />
            </IconButton>
        </InputAdornment>
    )
}